import { useState } from 'react'

import { NavigationLink } from '../../../components/NavigationLink'
import { Notifications } from '../../../components/Notifications'
import { ProfileMenu } from '../../../components/ProfileMenu'
import { SearchTask } from '../../../components/SearchTask'

export const DesktopMenu = () => {
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false)

  return (
    <div className="flex items-center justify-between w-full">
      <nav className="mr-3">
        <ul className="flex items-center gap-6">
          <li>
            <NavigationLink to="/painel/dashboard">Home</NavigationLink>
          </li>
          <li>
            <NavigationLink to="/painel/registers">Cadastros</NavigationLink>
          </li>
          {/* <li>
            <NavigationLink to="/painel/projects">Projetos</NavigationLink>
          </li> */}
          <li>
            <NavigationLink to="/painel/meetings">Reuniões</NavigationLink>
          </li>
          <li>
            <NavigationLink to="/painel/database">Base de dados</NavigationLink>
          </li>
          {/* <li>
            <NavigationLink to="/painel/requests">Request</NavigationLink>
          </li> */}
        </ul>
      </nav>

      <div className="flex items-center gap-8 ml-auto">
        <SearchTask />
        <Notifications
          isOpen={isNotificationsModalOpen}
          onClose={() => setIsNotificationsModalOpen(false)}
          onToggleOpen={() =>
            setIsNotificationsModalOpen((prevState) => !prevState)
          }
        />
        <ProfileMenu hasTranslations={false} hasTermOfParticipation={false} />
      </div>
    </div>
  )
}
